import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function extendUserPage() {
  extend(UserPage.prototype, 'navItems', function (items) {
    var _app$session$user;
    const user = this.user;
    const isSelf = (user == null ? void 0 : user.id()) === ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id());

    // Self-editing lives on the Settings page; only surface the profile tab when a
    // moderator is editing someone else's signature.
    if (user && !isSelf && user.canEditSignature()) {
      items.add('signature', m(LinkButton, {
        href: app.route('user.signature', {
          username: user.slug()
        }),
        icon: "fas fa-signature"
      }, app.translator.trans('fof-signature.forum.buttons.signature')), 20);
    }
  });
}
flarum.reg.add('fof-signature', 'forum/extenders/extendUserPage', extendUserPage);